<script setup lang="ts">
import type { NuxtLinkProps } from '#app'
import type { LinkFragment } from '#graphql-operations'

interface ButtonLinkProps {
  title?: string
  link?: LinkFragment
  to?: NuxtLinkProps['to']
  as?: 'button' | 'span'
}

const props = withDefaults(defineProps<ButtonLinkProps>(), {
  as: 'button',
})

const buttonLabel = computed(() => props.title || parseCraftLink(props.link)?.title)
</script>

<template>
  <Anchor
    v-if="to"
    :as
    :aria-label="buttonLabel"
    class="buttonLink"
    :to
  >
    <slot>
      <Text
        v-if="buttonLabel"
        :text="buttonLabel"
        class="text"
      />
    </slot>
  </Anchor>
  <CraftLink
    v-else-if="title || link"
    :link
    :as
    :aria-label="buttonLabel"
    class="buttonLink"
  >
    <slot>
      <Text
        v-if="buttonLabel"
        :text="buttonLabel"
        class="text"
      />
    </slot>
  </CraftLink>
</template>

<style scoped>
.buttonLink {
  display: inline-block;

  &:not([disabled]) {
    cursor: pointer;
  }
}

@media (hover: hover) and (pointer: fine) {
  :global(.group-buttonLink:hover),
  :global(.group-buttonLink:focus-within) {
    & .buttonLink::after {
      animation: underline-wipe 0.48s var(--ease-custom-circ) forwards;
    }
  }
}
</style>
